import streamApi from "@/api/streamApi";

export default {
  state: {
    data: 0
  },
  getters: {
    data: state => state.data
  },
  actions: {
    subscribe: ({ commit }, machine) => {
      if (machine) {
        const idForStreamApi = machine.Id;

        // New data model
        streamApi.subLatest(idForStreamApi, "Machine/Cnc/CncProcesses/01/FeedOverride", pub => {
          let _data = pub.data.v;
          _data = Math.round(_data, 2);
          commit("UPDATE", _data);
        });
      }
    },

    unsubscribe: ({ commit }, machine) => {
      if (machine) {
        const idForStreamApi = machine.Id;
        streamApi.unsub(idForStreamApi, "Machine/Cnc/CncProcesses/01/FeedOverride", () => {});
        streamApi.unsub(idForStreamApi, "Machine/Axes/Override", () => {});

        commit("RESET");
      }
    }
  },
  mutations: {
    UPDATE: (state, payload) => {
      //qui tutte le manipolazioni del caso
      state.data = payload;
    },
    RESET: state => {
      //qui tutte le manipolazioni del caso
      state.data = 0;
    }
  },
  namespaced: true
};
